import TcDevider from 'components/UI/Devider/TcDevider';
import TcInput from 'components/UI/form/input/TcInput';
import TcSelect from 'components/UI/form/input/TcSelect';
import TcSelectReduxSearch from 'components/UI/form/input/TcSelectReduxSearch';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import { customerCategory } from 'global/Models/userModel';
import { getAllCitiesWithoutSearch } from 'redux/reducer/basicData/allCitiesWithoutSearch';
import { getAllCustomerCategory } from 'redux/reducer/user/getAllCustomerCategory';

export const createPersonCustomerForm = (categoryChildren?: customerCategory[]) => (
  <TcFormWrapper>
    <TcFormItem label='عنوان کسب و کار' name='title' rules={[{ required: true, message: 'عنوان کسب و کار تعیین نشده' }]}>
      <TcInput placeholder='عنوان' />
    </TcFormItem>
    {/* <TcFormItem label='نام و نام خانوادگی' name='fullName' rules={[{ required: true, message: 'نام و نام خانوادگی تعیین نشده' }]}>
      <TcInput placeholder='نام و نام خانوادگی' />
    </TcFormItem> */}
    <TcFormItem label='نام' name='firstName' rules={[{ required: true, message: 'نام تعیین نشده' }]}>
      <TcInput placeholder='نام' />
    </TcFormItem>
    <TcFormItem label='نام خانوادگی' name='lastName' rules={[{ required: true, message: 'نام خانوادگی تعیین نشده' }]}>
      <TcInput placeholder='نام خانوادگی' />
    </TcFormItem>
    <TcFormItem label='کد ملی' name='nationalId' rules={[{ required: true, message: 'کد ملی تعیین نشده' }]}>
      <TcInput placeholder='کد ملی' maxLength={10} />
    </TcFormItem>
    <TcFormItem label='آدرس ایمیل' name='emailAddress' rules={[{ required: true, message: 'آدرس ایمیل وارد نشده' }]}>
      <TcInput placeholder='آدرس ایمیل' type='email' disabled />
    </TcFormItem>
    <TcFormItem label='شهر' name='cityId' rules={[{ required: true, message: ' شهر تعیین نشده.' }]}>
      <TcSelectReduxSearch reducerName='city' reducerListProperty='allCitiesWithoutSearch' getlist={getAllCitiesWithoutSearch} />
    </TcFormItem>
    <TcFormItem label='شماره موبایل' name='mobile' rules={[{ required: true, message: 'شماره موبایل وارد نشده' }]}>
      <TcInput placeholder='شماره موبایل' maxLength={11} />
    </TcFormItem>
    <TcFormItem label='تلفن' name='tel'>
      <TcInput placeholder='تلفن' maxLength={11} />
    </TcFormItem>
    <div className='col-span-full'>
      <TcDevider>گروه کسب و کار</TcDevider>
    </div>
    <TcFormItem label='طبقه' name='referenceId' rules={[{ required: true, message: 'گروه فعالیت تعیین نشده.' }]}>
      <TcSelectReduxSearch getlist={getAllCustomerCategory} reducerName='user' reducerListProperty='customerCategoryList' />
    </TcFormItem>
    {categoryChildren && categoryChildren?.length > 0 && (
      <TcFormItem label='گروه' name='categoryId' rules={[{ required: true, message: 'گروه فعالیت تعیین نشده.' }]}>
        <TcSelect options={categoryChildren?.map((item) => ({ value: item.id, label: item.title }))} disabled={!categoryChildren} />
      </TcFormItem>
    )}
  </TcFormWrapper>
);

export const createCompanyCustomerForm = (categoryChildren?: customerCategory[]) => (
  <TcFormWrapper>
    <TcFormItem label='عنوان شرکت' name='title' rules={[{ required: true, message: 'عنوان شرکت تعیین نشده' }]}>
      <TcInput placeholder='عنوان شرکت' />
    </TcFormItem>
    <TcFormItem label='شناسه ملی شرکت' name='nationalId' rules={[{ required: true, message: 'شناسه ملی شرکت تعیین نشده' }]}>
      <TcInput placeholder='شناسه ملی شرکت' maxLength={11} />
    </TcFormItem>
    <TcFormItem label='کد اقتصادی' name='finantialCode' rules={[{ required: true, message: 'عنوان شرکت تعیین نشده' }]}>
      <TcInput placeholder='کد اقتصادی' />
    </TcFormItem>
    <TcFormItem label='شماره ثبت' name='registrationCode' rules={[{ required: true, message: 'شماره ثبت تعیین نشده' }]}>
      <TcInput placeholder='شماره ثبت' />
    </TcFormItem>
    <TcFormItem label='شماره موبایل' name='mobile' rules={[{ required: true, message: 'شماره موبایل وارد نشده' }]}>
      <TcInput placeholder='شماره موبایل' maxLength={11} />
    </TcFormItem>
    <TcFormItem
      label='نام مدیر'
      name='managerName'
      // rules={[{ required: true, message: 'نام مدیر وارد نشده' }]}
    >
      <TcInput placeholder='نام مدیر' />
    </TcFormItem>
    <TcFormItem
      label='شماره موبایل مدیر'
      name='managerMobile'
      // rules={[{ required: true, message: 'شماره موبایل مدیر وارد نشده' }]}
    >
      <TcInput placeholder='شماره موبایل مدیر' maxLength={11} />
    </TcFormItem>
    <TcFormItem label='تلفن' name='tel'>
      <TcInput placeholder='تلفن' maxLength={11} />
    </TcFormItem>
    <TcFormItem label='آدرس ایمیل' name='emailAddress' rules={[{ required: true, message: 'آدرس ایمیل وارد نشده' }]}>
      <TcInput placeholder='آدرس ایمیل' type='email' disabled />
    </TcFormItem>
    <TcFormItem label='شهر' name='cityId' rules={[{ required: true, message: ' شهر تعیین نشده.' }]}>
      <TcSelectReduxSearch reducerName='city' reducerListProperty='allCitiesWithoutSearch' getlist={getAllCitiesWithoutSearch} />
    </TcFormItem>
    <div className='col-span-full'>
      <TcDevider>گروه کسب و کار</TcDevider>
    </div>
    <TcFormItem label='طبقه' name='referenceId' rules={[{ required: true, message: 'گروه فعالیت تعیین نشده.' }]}>
      <TcSelectReduxSearch getlist={getAllCustomerCategory} reducerName='user' reducerListProperty='customerCategoryList' />
    </TcFormItem>
    {categoryChildren && categoryChildren?.length > 0 && (
      <TcFormItem label='گروه' name='categoryId' rules={[{ required: true, message: 'گروه فعالیت تعیین نشده.' }]}>
        <TcSelect options={categoryChildren?.map((item) => ({ value: item.id, label: item.title }))} disabled={!categoryChildren} />
      </TcFormItem>
    )}
  </TcFormWrapper>
);
